import { useCallback, useEffect, useRef } from 'react';

type UnsubscribeHandler = () => void;

export type UseEntitySubscriptionsOutput = {
  subscribe: (entityId: string, unsubscribeHandler: UnsubscribeHandler) => void;
  unsubscribeFrom: (entityId: string) => void;
};

/**
 * Provides helpers for keeping an array of subscriptions regarding particular entities.
 */
export default function useEntitySubscriptions(): UseEntitySubscriptionsOutput {
  const unSubs = useRef<Record<string, UnsubscribeHandler>>({});

  const subscribe = useCallback((entityId: string, unsubscribeHandler: UnsubscribeHandler) => {
    if (!unSubs.current[entityId]) {
      unSubs.current[entityId] = unsubscribeHandler;
    }
  }, []);

  const unsubscribeFrom = useCallback((entityId: string) => {
    if (unSubs.current[entityId]) {
      unSubs.current[entityId]();
      delete unSubs.current[entityId];
    }
  }, []);

  useEffect(() => {
    const unSubsCurrent = unSubs.current;

    return () => Object.keys(unSubsCurrent).forEach(unsubscribeFrom);
  }, [unsubscribeFrom]);

  return { subscribe, unsubscribeFrom };
}
